import React from "react";
import { Link } from "react-router-dom";
import GetPath from "@Helpers/GetPath";
import { INSTANT_DEALS_WON } from "@Shared/Paths/Admin";
import { ChevronRight } from "../../../Supplier/Pages/PredictInstant/components/icons";
import iconStyles from "../../../Supplier/Pages/PredictInstant/components/icons/index.module.scss";
import breadcrumbStyles from "../../../Supplier/Pages/PredictInstant/components/PredictInstantBreadcrumb/index.module.scss";
import styles from "./Breadcrumb.module.scss";
export default ({ customerName }) => (React.createElement("div", { className: `${breadcrumbStyles.breadcrumb} ${breadcrumbStyles.embedded}` },
    React.createElement("div", { className: breadcrumbStyles.trail },
        customerName ? (React.createElement(Link, { to: GetPath(INSTANT_DEALS_WON), className: `${breadcrumbStyles.parent} ${styles.link}` }, "Instant Deals Won")) : (React.createElement("span", { className: breadcrumbStyles.parent }, "Instant Deals Won")),
        customerName && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: breadcrumbStyles.chevronWrap },
                React.createElement(ChevronRight, { className: `${iconStyles.icon} ${iconStyles.chevron}` })),
            React.createElement("span", { className: breadcrumbStyles.current }, customerName))))));
